<template>
  <eb-panel class="proj-rule-view-type-item">
    <eb-panel-header class="panel-header" slot="header">
      <span slot="title">{{ ruleTypeItemIndex + basePanelIndex +1 }} {{ruleTypeItem.ruleType}}</span>
    </eb-panel-header>
    <div slot="body">
      <ProjRuleViewListDigitalItem v-for="(item, $index) in ruleTypeItem.ruleItem" :key="$index" :ruleDigitalItem="item" :ruleDigitalItemIndex="$index"
        :ruleTypeItemIndex="ruleTypeItemIndex + basePanelIndex" />
    </div>
  </eb-panel>
</template>

<script>
import EbPanel from '@/components/common/panel/eb-panel';
import EbPanelHeader from '@/components/common/panel/eb-panel-header';
import ProjRuleViewListDigitalItem from './ProjRuleViewListDigitalItem';

export default {
  props: {
    ruleTypeItem: {
      type: Object,
      required: true
    },
    basePanelIndex: {
      type: Number,
      default: 0
    },
    ruleTypeItemIndex: {
      type: Number,
      required: true
    }
  },
  components: {
    EbPanel,
    EbPanelHeader,
    ProjRuleViewListDigitalItem
  },
  computed: {
    // ruleItemArr: function() {
    //   return this.ruleTypeItem.ruleItem.filter(item => {
    //     return item.ruleResult === true;
    //   });
    // }
  }
};
</script>

<style>

</style>
